import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
const volumes = [{
  title: 'PHASE DE FONDATION',
  description: 'Construisez des bases solides en football dès le premier jour. Mouvements fondamentaux, maîtrise du ballon et premiers gestes techniques pour bien démarrer.'
}, {
  title: 'DÉVELOPPEMENT DES COMPÉTENCES',
  description: 'Passe. Réception. Dribble. Finition. Progression technique. Des exercices progressifs pour perfectionner les gestes techniques essentiels de chaque joueur de football.'
}, {
  title: 'INTELLIGENCE DE JEU',
  description: 'Prise de décision. Vigilance. Scanning. Compréhension du jeu. Des situations pour apprendre aux joueurs à lire le jeu et à mieux décider sur le terrain de football.'
}, {
  title: "DÉVELOPPEMENT D'ÉQUIPE",
  description: 'Principes offensifs. Principes défensifs. Transitions. Jeu collectif. Des exercices collectifs pour construire une équipe de football plus organisée et plus forte.'
}, {
  title: 'LA BIBLIOTHÈQUE DE SÉANCES 365',
  description: "Une bibliothèque complète de séances d'entraînement prêtes à l'emploi pour chaque situation, couvrant toute la saison de football, sans rien à préparer."
}, {
  title: "SYSTÈME DE GESTION DE L'ENTRAÎNEUR",
  description: 'Planification. Organisation. Évaluation. Communication. Gestion de la saison. Des outils pratiques pour piloter votre saison de football en toute confiance.'
}];
export function Volumes() {
  return <section className="py-20 bg-navy-950 relative" data-id="element-246" data-mp="60pjiase9pwx">
      <div className="container mx-auto px-4" data-id="element-247" data-mp="kqeraouzss66">
        <div className="text-center mb-16" data-id="element-248" data-mp="ktaq0fenzkvo">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-anton text-4xl md:text-5xl text-white uppercase tracking-wide" data-id="element-249" data-mp="ftejo9ihvhcy">
LE SYSTÈME COMPLET EN 6 VOLUMES
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-250" data-mp="11t3o7ejam1z7">
          {volumes.map((vol, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-gradient-to-b from-navy-800 to-navy-900 border border-navy-700 rounded-xl p-8 relative overflow-hidden group hover:border-gold-500/50 transition-colors" data-id="element-251" data-mp="1bidk75h9c4sl" data-mpi={index}>
              <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-252" data-mp="3gs1mps0zh0">
                <BookOpen className="w-24 h-24 text-white" data-id="element-253" data-mp="2ddhz95cuoh7f" />
              </div>
              <div className="relative z-10" data-id="element-254" data-mp="28n1ipcdqgfgu">
                <div className="text-gold-500 font-oswald text-sm tracking-widest mb-2" data-id="element-255" data-mp="28lypuywuo2ya">
                  VOLUME {index + 1}
                </div>
                <h3 className="font-anton text-2xl text-white uppercase tracking-wide mb-4" data-id="element-256" data-mp="24j22yw0a1koj">
                  {vol.title}
                </h3>
                <p className="text-gray-400 font-medium leading-relaxed" data-id="element-257" data-mp="2wbkq7poyko7v">
                  {vol.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}